/* The dashboard summary. One request, so the numbers on the page cannot disagree. */

import { request } from '../client';
import { isMockTransport } from '../config';
import type { DashboardSummary } from '../types';

export async function fetchDashboard(): Promise<DashboardSummary> {
  if (isMockTransport()) {
    const { mockDashboard } = await import('@/mocks/handlers');
    return mockDashboard();
  }
  return request<DashboardSummary>('/dashboard/summary');
}
